import mitt from 'mitt';

export const bus = new mitt();

export const closePopup = () => bus.emit('close');
